import { createReducer } from "reduxsauce";
import Cookies from "js-cookie";

import { INITIAL_STATE } from "./initialState";
import { AuthTypes } from "./actions";

export const updateAuthTokens = (state, { accessToken, refreshToken }) => {
  Cookies.set("accessToken", accessToken);
  Cookies.set("refreshToken", refreshToken);
  return {
    ...state,
    accessToken,
  };
};

export const logout = (state) => {
  Cookies.remove("accessToken");
  Cookies.remove("refreshToken");
  return {
    ...state,
    ...INITIAL_STATE,
  };
};

export const setUser = (state, { user }) => {
  return {
    ...state,
    user,
  };
};

export const onLoginSuccess = (state, { data }) => {
  Cookies.set("accessToken", data.access_token);
  Cookies.set("refreshToken", data.refresh_token);
  return {
    ...state,
    accessToken: data.access_token,
    user: data.user,
  };
};

export const reducer = createReducer(INITIAL_STATE, {
  [AuthTypes.UPDATE_AUTH_TOKENS]: updateAuthTokens,
  [AuthTypes.LOGOUT]: logout,
  [AuthTypes.SET_USER]: setUser,
  [AuthTypes.ON_LOGIN_SUCCESS]: onLoginSuccess,
});
